import { i18n as I18n } from 'builder/utils/i18n'
import { Container, Step, StepNumber, StepTitle } from './styles'
import { useMainAppContext } from '../context/TemplatesGuestContext'

const TemplateGuestSteps = () => {
  const { currentStep } = useMainAppContext()
  const NAVBAR_STEPS = [
    { text: I18n.t('builder.sign_up.enter_details'), step: 0 },
    { text: I18n.t('builder.sign_up.choose_template'), step: 3 },
    { text: I18n.t('builder.sign_up.download_resume'), step: 5 },
  ]

  return (
    <Container>
      {NAVBAR_STEPS.map((item, i) => (
        <Step key={i}>
          <StepNumber visited={item.step <= currentStep}>{i + 1}</StepNumber>
          <StepTitle visited={item.step <= currentStep}>{item.text}</StepTitle>
        </Step>
      ))}
    </Container>
  )
}

export default TemplateGuestSteps
